import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

function PrivateRoute({ children, allowedRoles = [], requireAuth = true }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <LoadingSpinner message="Yükleniyor..." size="medium" />
      </div>
    );
  }

  // Eğer authentication gerekli değilse ve kullanıcı giriş yapmamışsa
  if (!requireAuth && !isAuthenticated) {
    return children;
  }

  // Eğer authentication gerekli ve kullanıcı giriş yapmamışsa
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Eğer kullanıcının şifresini değiştirmesi gerekiyorsa
  if (requireAuth && isAuthenticated && user?.shouldChangePassword) {
    return <Navigate to="/force-change-password" replace />;
  }

  // Eğer rol kontrolü varsa ve kullanıcının rolü uygun değilse
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    // Admin ve kargo personeli için kendi panellerine yönlendir
    if (user?.role === 'SUPER_ADMIN' || user?.role === 'COMPANY_ADMIN') {
      return <Navigate to="/admin" replace />;
    }
    if (user?.role === 'SHIPPING_STAFF') {
      return <Navigate to="/admin/orders" replace />;
    }
    // Normal kullanıcılar için dashboard'a yönlendir
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default PrivateRoute; 